define('ordersDetailPriceMain',[
  'module',
  'marionette',
  'underscore',
  'ordersDetailPriceController'
], function (
  Module,
  Marionette,
  _,
  Controller
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: _.template('<div class="view-region"></div>'),
    className: 'order-detail-price-main-view',

    regions: {
      viewRegion: '.view-region'
    },

    onShow: function () {        
      Controller.showPrice(this.getRegion('viewRegion'), this.model.get('order'));     
    }     
  });
});
